import { ASOS_PRODUCT_HTML_ID, MODAL_ANIMATION_TIME } from "../../constants";
import scrollTo from "../../utils/scrollTo/scrollTo";

export const isHeroProductWithoutLink = ({ product, productLink }) =>
  product.isHeroProduct && productLink === null;

export const closeModalAndScroll = ({ modalControls, event }) => {
  modalControls?.setFocusOnCloseElement?.(
    document.getElementById(ASOS_PRODUCT_HTML_ID),
  );
  modalControls?.closeModal?.();
  setTimeout(() => {
    scrollTo(ASOS_PRODUCT_HTML_ID, event);
  }, MODAL_ANIMATION_TIME + 100);
};
